// removed by extract-text-webpack-plugin
module.exports = {"financialInfo":"financial_financialInfo_2quj4","ant-table":"financial_ant-table_2pDFP","title":"financial_title_19h-u","financialTitle":"financial_financialTitle_2mozr","subtitle":"financial_subtitle_2KAKz","yearReport":"financial_yearReport_TvyXI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/baseInfo/financial/financial.scss
// module id = 1532
// module chunks = 0